<template>
    <vs-button
        class="ld-button"
        :class="{'smaller': size === 'smaller'}"
        :type="type"
        :color="color"
        :text-color="textColor"
        :icon="icon"
        :icon-pack="iconPack"
        :icon-after="iconAfter"
        :line-origin="lineOrigin"
        :line-position="linePosition"
        :radius="radius"
        :to="to"
        :href="href"
        :target="target"
        :size="size"
        v-on:click="$emit('click')"
    >

        <slot />

    </vs-button>
</template>

<script>
export default {
    name: 'LdButton',
    inheritAttrs: true,
    props: {
        size: {
            type: String,
            default: 'default'
        },
        buttonType: {
            type: String,
            default: 'button'
        },
        type: {
            type: String,
            default: 'filled',
        },
        color: {
            type: String,
            default: 'primary'
        },
        textColor: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        iconPack: {
            type: String,
            default: 'material-icons'
        },
        iconAfter: {
            type: Boolean,
            default: false,
        },
        lineOrigin: {
            type: String,
            default: 'center',
        },
        linePosition: {
            type: String,
            default: 'bottom',
        },
        radius: {
            type: Boolean,
            default: false
        },
        to: {
            type: [String, Object],
            required: false,
        },
        href: {
            type: [String, Object],
            required: false,
        },
        target: {
            type: Boolean,
            default: false
        },

    },
    methods: {
        setType() {
            this.$el.setAttribute('type', this.buttonType);
        }
    },
    mounted() {
        this.setType();
    },
}
</script>

<style lang="scss">
    .ld-button.smaller {
        padding: 6px 2rem !important;
    }
</style>
